export default {
  'человек': 'человек | человека | человек',
  'оценка': 'оценка | оценки | оценок',
}